/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Actions_Deletetooltip1Inputs */



/**
* | output |
* | --- |
* | "Delete this alarm" |
*
* @param {Alarms_Actions_Deletetooltip1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_actions_deletetooltip1 = /** @type {((inputs?: Alarms_Actions_Deletetooltip1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Actions_Deletetooltip1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Delete this alarm")
	return /** @type {LocalizedString} */ ("Supprimer cette alarme")
});
export { alarms_actions_deletetooltip1 as "alarms_actions_deleteTooltip" }